var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup5Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95579 23L5.21479 20.5357L11.3418 17.25L11.6871 13.9643L1.89947 4.92857L2.24481 1.64286H7.2005L7.37317 0H14.8067H22.2403L22.0676 1.64286H27.0233L26.6779 4.92857L14.9909 13.9643L14.6456 17.25L20.0819 20.5357L19.8229 23H12.3893H4.95579ZM7.85378 3.28571H4.54999L4.46365 4.10714L7.50844 6.57143L7.85378 3.28571ZM21.069 3.28571H24.3728L24.2864 4.10714L20.7236 6.57143L21.069 3.28571Z",
    fill: "#56628B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.741 4.79198C15.7128 4.79198 16.4028 5.41162 16.2479 7.04524L16.0085 9.38299C15.8818 10.6364 15.1213 11.425 13.6567 11.425C11.9808 11.425 11.4034 10.5096 11.5724 8.89009L11.671 7.96062L13.1356 7.96062L13.0088 9.15767C12.9384 9.77731 13.1638 10.0871 13.6848 10.0871C14.1918 10.0871 14.3608 9.73506 14.4171 9.22808L14.6565 6.91849C14.7129 6.39742 14.5157 6.05944 14.0651 6.05944C13.6003 6.05944 13.3328 6.38334 13.2623 7.01707L13.2483 7.14382L11.7836 7.14382L12.347 1.76416L16.5718 1.76416L16.431 3.07387L13.6707 3.07387L13.4173 5.45387H13.4313C13.6989 5.0173 14.1355 4.79198 14.741 4.79198Z",
    fill: "#161C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup5Updated);
export default __webpack_public_path__ + "static/media/cup-5-updated.7eec485e6ebfa00abe9298733236822a.svg";
export { ForwardRef as ReactComponent };